// extracted by mini-css-extract-plugin
export default {"warningBox":"WarningBox_warningBox__thb8Z"};